import { useState } from 'react'
import { X } from 'lucide-react'

export type AcceptClientData = {
  cnpj: string
  respAssinaturaNome: string
  respAssinaturaEmail: string
  respFinanceiroNome: string
  respFinanceiroEmail: string
}

type Props = {
  isOpen: boolean
  onClose: () => void
  onConfirm: (data: AcceptClientData) => Promise<void>
  initialData?: Partial<AcceptClientData & { responsavelAssinaturaNome?: string; responsavelAssinaturaEmail?: string; responsavelFinanceiroNome?: string; responsavelFinanceiroEmail?: string }>
}

export function ProposalAcceptWizard({ isOpen, onClose, onConfirm, initialData = {} }: Props) {
  const [loading, setLoading] = useState(false)
  const [formData, setFormData] = useState<AcceptClientData>({
    cnpj: initialData.cnpj || '',
    respAssinaturaNome: initialData.respAssinaturaNome || initialData.responsavelAssinaturaNome || '',
    respAssinaturaEmail: initialData.respAssinaturaEmail || initialData.responsavelAssinaturaEmail || '',
    respFinanceiroNome: initialData.respFinanceiroNome || initialData.responsavelFinanceiroNome || '',
    respFinanceiroEmail: initialData.respFinanceiroEmail || initialData.responsavelFinanceiroEmail || '',
  })
  const [isEditingCNPJ, setIsEditingCNPJ] = useState(!initialData.cnpj)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)
    try {
      await onConfirm(formData)
    } catch (err) {
      alert(err instanceof Error ? err.message : 'Erro ao aceitar proposta')
    } finally {
      setLoading(false)
    }
  }

  if (!isOpen) return null

  return (
    <div className="modal-overlay" onClick={onClose} style={{ zIndex: 2000 }}>
      <div
        className="modal modal-md v2-card"
        onClick={(e) => e.stopPropagation()}
        style={{ padding: '2rem', backgroundColor: '#ffffff', color: '#334155' }}
      >
        <div className="modal-header" style={{ marginBottom: '1.5rem', border: 'none' }}>
          <h2 style={{ fontSize: '1.5rem', fontWeight: 700, margin: 0, color: '#575757' }}>Aceitar Proposta</h2>
          <button type="button" className="btn-icon" onClick={onClose}><X size={20} /></button>
        </div>

        <form onSubmit={handleSubmit} className="v2-form">
          <p style={{ color: '#575757', marginBottom: '1.5rem', fontSize: '0.9rem' }}>
            Para prosseguirmos com a ativação, precisamos confirmar os dados cadastrais e os responsáveis legais.
          </p>

          <div className="form-group mb-4">
            <label className="label-v2">CNPJ da Empresa</label>
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <input
                required
                className={`input-v2 ${!isEditingCNPJ ? 'input-readonly' : ''}`}
                placeholder="00.000.000/0000-00"
                style={{ backgroundColor: '#f8fafc', color: '#0f172a', borderColor: '#cbd5e1' }}
                value={formData.cnpj}
                readOnly={!isEditingCNPJ}
                onChange={(e) => setFormData({ ...formData, cnpj: e.target.value })}
              />
              {!isEditingCNPJ && (
                <button type="button" className="btn-v2 btn-secondary" style={{ padding: '0.4rem 0.8rem', fontSize: '0.8rem', whiteSpace: 'nowrap' }} onClick={() => setIsEditingCNPJ(true)}>
                  Editar
                </button>
              )}
            </div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
            <div style={{ gridColumn: 'span 2' }}>
              <h4 style={{ fontSize: '0.85rem', color: '#14bdbd', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '0.75rem' }}>Responsável pela Assinatura</h4>
            </div>
            <div className="form-group">
              <label className="label-v2">Nome Completo</label>
              <input required className="input-v2" style={{ backgroundColor: '#f8fafc', color: '#0f172a', borderColor: '#cbd5e1' }} value={formData.respAssinaturaNome} onChange={(e) => setFormData({ ...formData, respAssinaturaNome: e.target.value })} />
            </div>
            <div className="form-group">
              <label className="label-v2">E-mail</label>
              <input required type="email" className="input-v2" style={{ backgroundColor: '#f8fafc', color: '#0f172a', borderColor: '#cbd5e1' }} value={formData.respAssinaturaEmail} onChange={(e) => setFormData({ ...formData, respAssinaturaEmail: e.target.value })} />
            </div>
            <div style={{ gridColumn: 'span 2', marginTop: '0.5rem' }}>
              <h4 style={{ fontSize: '0.85rem', color: '#14bdbd', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '0.75rem' }}>Recebimento do Boleto Financeiro</h4>
            </div>
            <div className="form-group">
              <label className="label-v2">Nome do Contato</label>
              <input required className="input-v2" style={{ backgroundColor: '#f8fafc', color: '#0f172a', borderColor: '#cbd5e1' }} value={formData.respFinanceiroNome} onChange={(e) => setFormData({ ...formData, respFinanceiroNome: e.target.value })} />
            </div>
            <div className="form-group">
              <label className="label-v2">E-mail Financeiro</label>
              <input required type="email" className="input-v2" style={{ backgroundColor: '#f8fafc', color: '#0f172a', borderColor: '#cbd5e1' }} value={formData.respFinanceiroEmail} onChange={(e) => setFormData({ ...formData, respFinanceiroEmail: e.target.value })} />
            </div>
          </div>

          <div className="flex gap-md mt-6" style={{ marginTop: '2rem', display: 'flex', gap: '1rem' }}>
            <button type="button" className="btn-v2 btn-secondary w-full" onClick={onClose} disabled={loading} style={{ color: '#334155', flex: 1 }}>Cancelar</button>
            <button type="submit" className="btn-v2 btn-primary w-full" disabled={loading} style={{ flex: 1 }}>
              {loading ? 'Processando...' : 'Solicitação de Contrato em andamento'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}
